import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo, useState, useRef, useEffect } from 'react';
import Dropdown from '@uiw/react-dropdown';
import Icon from '@uiw/react-icon';
import Input from '@uiw/react-input';
import Tag from '@uiw/react-tag';
import Card from '@uiw/react-card';
import Empty from '@uiw/react-empty';
import "./style/index.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TagSize = {
  large: 25,
  default: 20,
  small: 17
};
function SearchTagInput(props) {
  var {
    prefixCls = 'w-search-tree',
    size = 'default',
    disabled = false,
    allowClear = false,
    loading = false,
    selectCloseDrop = false,
    className,
    style,
    placeholder,
    tagProps = {},
    content,
    options,
    values,
    onChange,
    onSearch,
    emptyOption
    // ...others
  } = props;
  var cls = [prefixCls, className].filter(Boolean).join(' ').trim();
  var [innerIsOpen, setInnerIsOpen] = useState(false);
  var [selectedOption, setSelectedOption] = useState(values);
  var optionRef = useRef();
  var [searchValue, searchValueSet] = useState('');
  optionRef.current = useMemo(() => selectedOption, [selectedOption]);
  var [selectIconType, setSelectIconType] = useState('');
  var inputRef = useRef(null);
  useEffect(() => {
    setSelectedOption(values);
  }, [JSON.stringify(values)]);
  function renderSelectIcon(type) {
    var selectIconType = type === 'enter' && allowClear && (!!selectedOption.length || searchValue) ? 'close' : '';
    setSelectIconType(selectIconType);
  }
  var handleSelectChange = function handleSelectChange(selectedAll, selectd, isChecked) {
    if (isChecked === void 0) {
      isChecked = true;
    }
    setSelectedOption(selectedAll);
    searchValueChange('');
    onChange == null || onChange(selectedAll, selectd, isChecked);
  };
  var removeSelectItem = index => {
    var selectedOption = optionRef.current;
    var curreentItem = selectedOption[index];
    selectedOption.splice(index, 1);
    handleSelectChange([...selectedOption], curreentItem, false);
  };
  function handleInputChange(value) {
    setInnerIsOpen(true);
    searchValueChange(value);
    setSelectIconType(value ? 'loading' : '');
  }
  var searchValueChange = value => {
    searchValueSet(value);
    onSearch == null || onSearch(value);
  };

  // 清除选中的值
  function resetSelectedValue(e) {
    var _inputRef$current;
    e.stopPropagation();
    (_inputRef$current = inputRef.current) == null || _inputRef$current.focus();
    handleInputChange('');
    setInnerIsOpen(false);
    setSelectedOption([]);
    handleSelectChange([]);
  }
  function inputKeyDown(e) {
    if (selectedOption.length > 0 && !searchValue && e.keyCode === 8) {
      removeSelectItem(selectedOption.length - 1);
    }
  }
  var newContent = useMemo(() => {
    if (emptyOption) {
      return typeof emptyOption === 'boolean' ? /*#__PURE__*/_jsx(Empty, {
        style: {
          minWidth: 200,
          width: style == null ? void 0 : style.width
        }
      }) : emptyOption;
    }
    var newProps = _extends({}, content.props, {
      onSelected: function onSelected(selectedAll, selectd, isChecked) {
        if (isChecked === void 0) {
          isChecked = true;
        }
        setInnerIsOpen(!selectCloseDrop);
        handleSelectChange(selectedAll, selectd, isChecked);
      },
      values: selectedOption,
      options
    });
    return /*#__PURE__*/React.cloneElement(content, newProps);
  }, [JSON.parse(JSON.stringify(selectedOption)), options, emptyOption]);
  return /*#__PURE__*/_jsx(Dropdown, {
    className: cls,
    trigger: "click",
    onVisibleChange: isOpen => {
      setInnerIsOpen(isOpen);
      if (!isOpen) searchValueChange('');
    },
    disabled: disabled,
    isOpen: innerIsOpen,
    menu: /*#__PURE__*/_jsx(Card, {
      bodyStyle: emptyOption === true ? {
        padding: 0
      } : undefined,
      children: newContent
    }),
    children: /*#__PURE__*/_jsx("div", {
      onMouseOver: () => renderSelectIcon('enter'),
      onMouseLeave: () => renderSelectIcon('leave'),
      onClick: () => {
        var _inputRef$current2;
        return (_inputRef$current2 = inputRef.current) == null ? void 0 : _inputRef$current2.focus();
      },
      style: _extends({
        minWidth: (style == null ? void 0 : style.width) || 200,
        maxWidth: 'none'
      }, style),
      children: /*#__PURE__*/_jsxs("div", {
        className: [prefixCls + "-inner", prefixCls + "-" + size].filter(Boolean).join(' ').trim(),
        children: [/*#__PURE__*/_jsxs("div", {
          style: {
            display: 'flex',
            flexFlow: 'wrap',
            width: '100%'
          },
          children: [selectedOption.map((item, index) => {
            return /*#__PURE__*/_jsx(Tag, _extends({
              style: {
                height: TagSize[size],
                margin: 1,
                display: 'flex',
                alignItems: 'center'
              },
              className: prefixCls + "-tag",
              closable: true,
              color: "#393E48"
            }, tagProps, {
              disabled: disabled,
              onClose: e => {
                e.stopPropagation();
                removeSelectItem(index);
              },
              children: item.label
            }), index);
          }), /*#__PURE__*/_jsx(Input, {
            ref: inputRef,
            className: prefixCls + "-input-contents",
            size: size,
            disabled: disabled,
            onKeyDown: inputKeyDown,
            onChange: e => handleInputChange(e.target.value),
            value: searchValue,
            placeholder: selectedOption.length ? '' : placeholder
          })]
        }), !disabled && /*#__PURE__*/_jsx("span", {
          style: {
            height: 25,
            width: 14
          },
          className: prefixCls + "-close-tag-contents",
          children: (selectIconType === 'close' || selectIconType === 'loading' && loading) && /*#__PURE__*/_jsx(Icon, {
            type: selectIconType,
            spin: loading && selectIconType === 'loading',
            onClick: resetSelectedValue
          })
        })]
      })
    })
  });
}
export default SearchTagInput;